<template>
  <div>
    <v-alert
      v-model="$store.state.alert.display"
      class="defaultAlert"
      transition="scale-transition"
      color="blue"
      dark
      dismissible
      icon="mdi-account"
      outlined
      max-width="600px"
      width="520px"
    >
      <p style="margin-bottom: 0px;" v-html="$store.state.alert.msg"></p>
    </v-alert>
  </div>
</template>
<style scoped>
.defaultAlert {
  margin: 30px;
  position: fixed;
  right: 8px;
  bottom: 8px;
  z-index: 1000;
  background: white !important;
  border: thin solid currentColor !important;
  white-space: pre-line;
}
</style>
<script>
export default {};
</script>
